import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useTheme,
} from "@mui/material";

export type MessageModalProps = {
  open: boolean;
  message: string;
  handleClose: () => void;
};

export const MessageModal = (props: MessageModalProps) => {
  const theme = useTheme();
  return (
    <Box>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        PaperProps={{
          sx: {
            width: { xs: "50vw", md: "30vw", lg: "30vw" },
            maxWidth: { xs: "50vw", md: "30vw", lg: "30vw" },
            backgroundColor: theme.palette.custom.sForm,
            // height: { xs: "30vh", lg: "30vh" },
            // maxHeight: { xs: "30vh", lg: "30vh" },
          },
        }}
      >
        <DialogTitle>Message</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "pre-line",
          }}
        >
          {props.message}
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
